import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import StatusCell from '@cas/components/data-display/status-cell/StatusCell';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyCell } from '../../formatters/genericFormatters';
import { AssetDeviceType, RegisteredAssetModel } from '@casops/store/apis/registeredAssetsApi';

interface HealthStatusCellRendererProps {
  value?: boolean;
  data: RegisteredAssetModel;
}

export default function HealthStatusCellRenderer({
  value,
  data,
}: HealthStatusCellRendererProps): ReactElement | string {
  const { t } = useTranslation();

  if (typeof value !== 'boolean' || !data || data.hw === AssetDeviceType.PPU) {
    return EmptyCell;
  }

  return (
    <StatusCell
      label={value ? t('NoActiveFaults') : t('ActiveFaults')}
      status={value ? BadgeStatus.Healthy : BadgeStatus.Danger}
    />
  );
}
